import styled from "styled-components";
import { SyncOutlined } from "@ant-design/icons";
import { BONUS } from "@assets";
import { Divider as AntDivider } from "antd";
import { getStatusColor, getUseNotUseColor } from "@utils";

export const RootContainer = styled.div`
  position: relative;
`;

export const RefreshIcon = styled(SyncOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const Container = styled.div`
  position: relative;
  background: ${(props) => props.theme.white};
  margin: 0px 24px;
  border-radius: 12px;

  @media screen and (max-width: 327px) {
    margin: 0px 14px;
  }
  @media screen and (max-width: 300px) {
    margin: 0px 10px;
  }
`;

export const Top = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;

  .ant-space {
    padding-top: 12px;
    grid-gap: 16px !important;
  }

  .ant-btn-default {
    color: ${(props) => props.theme.textColor} !important;
    background: ${(props) => props.theme.golden} !important;
    border-color: ${(props) => props.theme.golden} !important;
    height: 35px !important;
  }
`;

export const LightTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LightText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${(props) => props.theme.dark3};
`;

export const Text = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: ${(props) => props.theme.buttonDisabled};
`;

export const ActionsWrapper = styled.div`
  padding-top: 37px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const Box = styled.div`
  width: 80%;
  padding: 16px 0;
  border-radius: 5px;
  border: 1px solid #e1cce0;
  background-color: #fff;
  filter: drop-shadow(0px 3px 6px #e1cce0);

  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #e1cce0;
  height: 55px;
`;

export const ActionButton = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-gap: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    font-size: 32px;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #000;
`;

export const ListContainer = styled.div`
  height: calc(100vh - 350px);
  overflow-y: auto;
`;

export const TitleWrapper = styled.div`
  display: flex;
`;

export const Title = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
`;

export const LinkText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #73217d;
  cursor: pointer;
`;

export const ListWrapper = styled.div`
  overflow-y: auto;
  padding: 0px 16px;

  > :nth-child(1) {
    padding-top: 0;
  }

  > :last-child {
    margin: 0 0 50px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px 0;
  display: flex;
  grid-gap: 12px;
  align-items: flex-start;
  border-bottom: 1px solid ${props => props.theme.dark4};

  > :nth-child(2) {
    flex: 1;
  }

  > :nth-child(3) {
    text-align: right;
  }
`;

export const ItemText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${props => props.theme.textColor};
  text-transform: capitalize;

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${props => props.theme.dark2};

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.textColor};

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const StatusText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => getStatusColor(props.status).color};
  background: ${(props) => getStatusColor(props.status).background};
  text-transform: capitalize;
  text-align: center;
  border-radius: 27px;
  padding: 1px 5px;

  @media screen and (max-width: 375px) {
    font-size: 10px;
  }
`;

export const BonusStatusText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => getUseNotUseColor(props.status).color};
  background: ${(props) => getUseNotUseColor(props.status).background};
  text-transform: capitalize;
  text-align: center;
  border-radius: 27px;
  padding: 1px 5px;

  @media screen and (max-width: 375px) {
    font-size: 10px;
  }
`;

export const ImageWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${props => props.theme.dark4};
`;

export const LogoImage = styled.img.attrs({
  alt: "img",
  src: BONUS,
})`
  width: 15px;
  border-radius: 50%;
  object-fit: contain;
  align-self: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 32px;
  border-radius: ${(props) => (props.radius === "none" ? "none" : "50%")};
  object-fit: contain;
  align-self: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  min-width: 60px;
`;

export const Bottom = styled.div`
  padding: 0 16px 24px 16px;
`;

export const BottomImage = styled.img.attrs({
  alt: "bottom-img",
})`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 3 / 1;
  border-radius: 5px;
  cursor: pointer;
`;

export const EmptyBox = styled.div`
  text-align: center;
  font-size: 12px;
  color: gray;

  .anticon {
    margin-bottom: 6px;
  }

  svg {
    font-size: 25px;
  }
`;

export const SpinWrapper = styled.div`
  text-align: center;
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;
`;

export const MyWalletContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${(props) => props.theme.dark4};
  border-radius: 23px;
  padding: 8px 10px;
  cursor: pointer;
  margin: 5px;
  min-width: 110px;

  @media screen and (max-width: 327px) {
    width: 100%;
  }
`;

export const MyWalletLabel = styled.span`
  color: ${(props) => props.theme.textColor};
  padding-right: 23px;
  font-size: 12px;
  font-weight: 600;
`;

export const RecentHistoryTitle = styled(AntDivider)`
  .ant-divider-inner-text {
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.theme.textColor};
    background: ${props => props.theme.white};
    border-radius: 21px;
    padding: 4px 16px 4px 16px;
    border: 1px solid ${props => props.theme.dark4};
  }

  padding: 0px;
  margin: 0px;

  ::before,
  ::after {
    border: 1px solid ${props => props.theme.dark4};
    border-color: ${props => props.theme.divider} !important;
  }
`;

export const SellAllWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  border-radius: 0px 0px 12px 12px !important;

  .ant-btn-primary {
    width: 100%;
    border-radius: 0px 0px 12px 12px !important;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3px;
`;

export const Subtitle = styled.div`
  color: #B48533;
  font-size: 12px;
  font-weight: 400;
  padding-left: 5px;
  padding-right: 5px;
`;

export const Sublabel = styled.div`
  color: #6C6559;
  font-size: 12px;
  font-weight: 600;
`;

export const ExpiredContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpiredText = styled.div`
  color: ${props => props.theme.error};
  font-size: 12px;
  margin-right: 3px;
`;